jQuery(document).ready(function ($) {

    jQuery.fn.isInViewport = function () {
        var elementTop = jQuery(this).offset().top;
        var elementBottom = elementTop + jQuery(this).outerHeight();

        var viewportTop = jQuery(window).scrollTop();
        var viewportBottom = viewportTop + jQuery(window).height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
    };

    // Fixed person circle
    $(window).on('resize scroll', function () {
        var personElements = jQuery('.field--name-field-person');

        if (personElements.length && personElements.isInViewport()) {
            jQuery('body').removeClass('person-fixed-circle black-layer');
            jQuery('.person-viewtype-circle').removeClass('bubble-active');
        } else {
            jQuery('body').addClass('person-fixed-circle');
        }
    });


    // Cookie withdraw banner - add close button
    $('#sliding-popup .eu-cookie-withdraw-banner .popup-content #popup-buttons').append('<button type="button" class="close-button eu-cookie-compliance-default-button">OK</button>');

    // Privacy settings - trigger for menu link and close button
    $('nav#block-voet > ul.menu > li a.privacy-settings-link,' + '#sliding-popup .popup-content #popup-buttons .close-button').click(function () {
        $('#sliding-popup .eu-cookie-withdraw-tab').trigger('click');
        return false;
    });


    if (jQuery(window).width() > 800) {
        window.sr = ScrollReveal({
            delay: 0,
            duration: 500,
            distance: '15px',
            easing: 'ease-in-out',
            scale: 1
        });
        sr.reveal('.path-frontpage .header-blocks-container > *', 100);
        sr.reveal('.path-frontpage .field--name-field-contentblocks .contentblock', {delay: 500}, 200);
    }

    jQuery(document).ajaxComplete(function (event) {
        mainHandler();
    });
    mainHandler();

    //Als er een formulier op de pagina staat en er is een bevestigingsmelding of een foutmelding, dan naar form scrollen
    if (jQuery('.field--name-field-form .webform-confirmation, form.webform-submission-form .messages--error, .field--name-field-footer-form .webform-confirmation, form.webform-submission-form .messages--error').length) {
        jQuery('html, body').animate({
            scrollTop: jQuery('form.webform-submission-form').offset().top
        }, 800);
    }

    jQuery(window).scroll(function (event) {
        if (jQuery(this).scrollTop() > 100) {
            if (jQuery(document).height() > jQuery(window).height() * 1.20) {
                jQuery('body').addClass('fixed-header');
            }
        } else {
            jQuery('body').removeClass('fixed-header');
        }
    });

    jQuery('body').on('click touchstart', function (event) {
        if (!jQuery(event.target).closest('.person-viewtype-circle.bubble-active, .person-viewtype-horizontal.bubble-active').length) {
            jQuery('.person-viewtype-circle, .person-viewtype-horizontal').removeClass('bubble-active');
            jQuery('body').removeClass('black-layer');
        }
    });

    if (jQuery('.field--name-field-subpages > .field__item').length) {
        jQuery('.field--name-field-subpages').addClass('owl-carousel').owlCarousel({
            margin: 25,
            nav: true,
            dots: false,
            responsive: {
                0: {
                    items: 1
                },
                480: {
                    items: 2
                },
                768: {
                    items: 3
                },
                1024: {
                    items: 5
                }
            }
        });
    }

    if (jQuery('.field--name-dynamic-block-fieldnode-contactform').length) {
        if (jQuery('.field--name-field-contentblock-bottom .cta-button').length) {
            jQuery('.field--name-field-contentblock-bottom .cta-button').click(function (event) {
                event.preventDefault();
                jQuery('.field--name-dynamic-block-fieldnode-contactform').show();
                jQuery(this).hide();
            });
        } else {
            jQuery('.field--name-dynamic-block-fieldnode-contactform').show();
        }
    }


    jQuery('a.youtube-popup').magnificPopup({
        disableOn: 700,
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false
    });

    jQuery('.poster-thumbnail a').magnificPopup({
        type: 'image',
        closeOnContentClick: false,
        closeBtnInside: false,
        mainClass: 'mfp-with-zoom mfp-img-mobile',
        image: {
            verticalFit: true,
        },
        zoom: {
            enabled: true,
            duration: 300, // don't foget to change the duration also in CSS
            opener: function (element) {
                return element.find('img');
            }
        }
    });

    if (jQuery('.person-viewtype-circle').length) {
        jQuery('.person-viewtype-circle').each(function (index) {
            var elems = jQuery(this).find('.field--name-field-phonenumber, .field--name-field-emailaddress, .field--name-field-linkedin-profile, .field--name-field-whatsapp-number').clone();
            var closeButton = jQuery('<div />').addClass('toggle-button');
            closeButton.click(function (event) {
                if (jQuery(this).closest('.person-viewtype-circle').hasClass('bubble-active')) {
                    jQuery(this).closest('.person-viewtype-circle').removeClass('bubble-active');
                    jQuery('body').removeClass('black-layer');
                    event.stopImmediatePropagation();
                }

            });
            jQuery(this).find('.content-container').append(elems);
            jQuery(this).find('.field--name-field-image').append(closeButton);
            jQuery(this).click(function (event) {
                if (!jQuery(this).hasClass('bubble-active')) {
                    event.preventDefault();
                }
                jQuery(this).addClass('bubble-active');
                jQuery('body').addClass('black-layer');
            });
        });
    }

    //Escape afvangen
    jQuery(document).keydown(function (e) {
        if (e.keyCode == 27) {
            //Close contactperson buble at escapebutton press
            jQuery('.person-viewtype-circle, .person-viewtype-horizontal').removeClass('bubble-active');
            jQuery('body').removeClass('black-layer');
        }
    });

    if (jQuery(window).width() < 480) {
        jQuery('body').on('focus', '.ui-dialog', function () {
            jQuery('body').addClass('mobile-modal-visible');
        });
        jQuery('body').on('blur', '.ui-dialog', function () {
            jQuery('body').removeClass('mobile-modal-visible');
        });
    }

    if (Drupal.eu_cookie_compliance.hasAgreed()) {
        jQuery('.field--name-dynamic-block-fieldnode-addthis-icons').css('visibility', 'visible');
    }

    jQuery('.field--name-field-emailaddress a').each(function (index) {
        var email_regex = /###([a-zA-Z0-9/+]*={0,2})###/gi;
        var linkElem = jQuery(this).clone().wrap('<div/>').parent().html();
        var match;
        while ((match = email_regex.exec(linkElem)) !== null) {
            var emailbase64 = match[0].replace('#', '');
            var rpRegex = new RegExp(match[0], 'g');
            linkElem = linkElem.replace(rpRegex, Base64.decode(emailbase64));
            // console.log(match);
        }

        jQuery(this).replaceWith(linkElem);

    });

    $('.page-node-type-homepage-v2 #page-wrapper > main .region-content .block-system-main-block > .footer-container .footer-container-inner .field--name-footer-location-text').each(function (index) {
        if ($(this).find('a').length == 1) {
            $(this).addClass('clickable').click(function (event) {
                window.location = $(this).find('a').attr('href');
            });
        }
    });

    $('.field--name-field-person:has(.person-viewtype-horizontal-with-text)').addClass('has_person-horizontal');
});

var Base64 = {
    _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", encode: function (e) {
        var t = "";
        var n, r, i, s, o, u, a;
        var f = 0;
        e = Base64._utf8_encode(e);
        while (f < e.length) {
            n = e.charCodeAt(f++);
            r = e.charCodeAt(f++);
            i = e.charCodeAt(f++);
            s = n >> 2;
            o = (n & 3) << 4 | r >> 4;
            u = (r & 15) << 2 | i >> 6;
            a = i & 63;
            if (isNaN(r)) {
                u = a = 64
            } else if (isNaN(i)) {
                a = 64
            }
            t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a)
        }
        return t
    }, decode: function (e) {
        var t = "";
        var n, r, i;
        var s, o, u, a;
        var f = 0;
        e = e.replace(/[^A-Za-z0-9+/=]/g, "");
        while (f < e.length) {
            s = this._keyStr.indexOf(e.charAt(f++));
            o = this._keyStr.indexOf(e.charAt(f++));
            u = this._keyStr.indexOf(e.charAt(f++));
            a = this._keyStr.indexOf(e.charAt(f++));
            n = s << 2 | o >> 4;
            r = (o & 15) << 4 | u >> 2;
            i = (u & 3) << 6 | a;
            t = t + String.fromCharCode(n);
            if (u != 64) {
                t = t + String.fromCharCode(r)
            }
            if (a != 64) {
                t = t + String.fromCharCode(i)
            }
        }
        t = Base64._utf8_decode(t);
        return t
    }, _utf8_encode: function (e) {
        e = e.replace(/rn/g, "n");
        var t = "";
        for (var n = 0; n < e.length; n++) {
            var r = e.charCodeAt(n);
            if (r < 128) {
                t += String.fromCharCode(r)
            } else if (r > 127 && r < 2048) {
                t += String.fromCharCode(r >> 6 | 192);
                t += String.fromCharCode(r & 63 | 128)
            } else {
                t += String.fromCharCode(r >> 12 | 224);
                t += String.fromCharCode(r >> 6 & 63 | 128);
                t += String.fromCharCode(r & 63 | 128)
            }
        }
        return t
    }, _utf8_decode: function (e) {
        var t = "";
        var n = 0;
        var r = c1 = c2 = 0;
        while (n < e.length) {
            r = e.charCodeAt(n);
            if (r < 128) {
                t += String.fromCharCode(r);
                n++
            } else if (r > 191 && r < 224) {
                c2 = e.charCodeAt(n + 1);
                t += String.fromCharCode((r & 31) << 6 | c2 & 63);
                n += 2
            } else {
                c2 = e.charCodeAt(n + 1);
                c3 = e.charCodeAt(n + 2);
                t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
                n += 3
            }
        }
        return t
    }
}

function mainHandler() {
    if (jQuery('.view-inspirationlab-article-overview').length) {
        jQuery('.view-inspirationlab-article-overview').filterLinks();
    }

    jQuery('.contentblock-header, .view-cta-block .view-content .views-row, .field--name-field-subpages .field__item, .field--nxame-field-country-blocks > .country-block, .view-searchresults .views-row, .block-views-blocksimplified-cases-overview-block-1 .views-row .simplified-case, .view-inspirationlab-article-overview .views-row .inspirationlab-item, .block-views-blocknewsoverview-block-1 .views-row .newsitem, .field--name-field-footer-contentblocks.field__items > *, .field--name-field-contactblocks.field__items > *, .field--name-field-contentblocks > *, .field--name-field-contentblocks-2 .field__items > *, .block-views-blockfooter-contentblocks-block-1 .views-row > .views-field-field-footer-contentblocks > .field-content').each(function (index) {
        if (jQuery(this).find('a').length == 1) {
            if (jQuery(this).find('a[href$=pdf]').length) {
                jQuery(this).find('a').attr('target', '_blank');
            }
            jQuery(this).addClass('clickable').click(function (event) {
                if (jQuery(event.target).is('a')) return;
                if (jQuery(this).find('a[href$=pdf]').length) {
                    window.open(jQuery(this).find('a').attr('href'));
                } else {
                    window.location.href = jQuery(this).find('a').attr('href');
                }
            });
        }
    });
}

let searchBar = document.querySelector('.region-header form[id^="ef2-custom-search-form"]');

if (searchBar) {
    let searchButton = searchBar.querySelector('[id*="edit-submit"]');
    let searchInput = searchBar.querySelector('[id*="edit-keys"]');

    searchButton.addEventListener('click', function(e) {
        if (searchBar.classList.contains('active-search') && searchInput.value !== null || searchInput.value !== '') {
            return;
        }

        if (searchBar.classList.contains('active-search')) {
            searchBar.classList.remove('active-search');
            document.body.classList.remove('search-bar-open');
            return;
        }

        e.preventDefault();
        searchBar.classList.add('active-search');
        document.body.classList.add('search-bar-open');
    });

    document.addEventListener('click', function(e) {
        if (e.target.classList.contains('form-text') || e.target.classList.contains('form-submit')) {
            return;
        }

        searchBar.classList.remove('active-search');
        document.body.classList.remove('search-bar-open');
    });
}

// Make whole card clickable
function handleElementLink(element) {
    const link = element.getElementsByTagName('A')[0];

    if (_.isNil(link)) {
        return;
    }

    clickableCard(element, link);
}

function clickableCard(element, link) {
    element.addEventListener('click', (e) => {
        if (link.getAttribute('target') === '_blank') {
            window.open(link, '_blank');
            return;
        }

        window.open(link, '_self');
    })

    element.style.cursor = 'pointer';
    element.classList.add('clickable');
}

const headerblocks = document.querySelectorAll('.paragraph-header-block, .paragraph--type--header-cta');

if (!_.isEmpty(headerblocks)) {
    Array.from(headerblocks).forEach(headerblock => handleElementLink(headerblock));
}

const teasercases = document.querySelectorAll('.teaser-case');

if (!_.isEmpty(teasercases)) {
    Array.from(teasercases).forEach(teasercase => handleElementLink(teasercase));
}

const teaserdisciplines = document.querySelectorAll('.view-disciplines .view-content > .views-row');

if (!_.isEmpty(teaserdisciplines)) {
    Array.from(teaserdisciplines).forEach(teaserdiscipline => handleElementLink(teaserdiscipline));
}